import { buildAdTargeting } from 'components/advert/ad-targeting/targetting-static.js';
import { BannerAd } from 'components/advert/advert-banner.js';
import { InterstitialPortal } from 'components/interstitial/interstitial-portal.js';
import { AdvertSkins } from 'page/advert-skins.js';
import * as React from 'react';
import { IAdvertisingConfigRaw, IBaseAdConfig } from 'redux-state/advertisement/types.js';
import { AdPageInitProvider } from './main-3-ads-page-change-init-provider.js';
import { getInterstitalAdLayout } from './main-3-ads-wrapper-v2-utils.js';
import { MainPageLayoutV2 } from './main-4-layout-v2.js';
import { PageJSONLoad } from './utils/json-fetch-page.js';
import { JsonResultType } from './utils/json-page-change.js';

const getInterstitialData = (pageJson: JsonResultType): IBaseAdConfig | undefined => {
  if (pageJson.type === PageJSONLoad.Success) {
    const interstitalData = getInterstitalAdLayout(pageJson?.pageJson.advertising.interstitial, true);
    if (interstitalData) {
      /** We add shared interstitial data here as initial loads may not have time to load  */
      const mergeSharedTargeting = buildAdTargeting({
        baseTarget: pageJson?.pageJson.advertising.targeting?.staticData ?? [],
        targeting: interstitalData?.targeting,
        overrideBaseTargeting: false,
        mergeBaseTargeting: false,
      });
      const newInterstitialConfig: IBaseAdConfig = Object.assign(interstitalData, { targeting: mergeSharedTargeting });
      return newInterstitialConfig;
    }
  }
  return undefined;
};

const getSkinData = (pageJson: JsonResultType) => {
  if (pageJson.type === PageJSONLoad.Success) {
    const skinData = pageJson?.pageJson.advertising.skin;
    if (skinData) {
      /** We add shared interstitial data here as initial loads may not have time to load  */
      const mergeSharedTargeting = buildAdTargeting({
        baseTarget: pageJson?.pageJson.advertising.targeting?.staticData ?? [],
        targeting: skinData?.targeting,
        overrideBaseTargeting: false,
        mergeBaseTargeting: false,
      });
      const newSkinAdConfig: IAdvertisingConfigRaw['skin'] = Object.assign(skinData, {
        targeting: mergeSharedTargeting,
      });
      return newSkinAdConfig;
    }
  }
  return undefined;
};

const getBannerAdData = (pageJson: JsonResultType) => {
  if (pageJson.type === PageJSONLoad.Success) {
    const bannerConfig = pageJson.pageJson.advertising.bannerConfig;
    if (bannerConfig) {
      /** We add shared interstitial data here as initial loads may not have time to load  */
      const mergeSharedTargeting = buildAdTargeting({
        baseTarget: pageJson?.pageJson.advertising.targeting?.staticData ?? [],
        targeting: bannerConfig?.targeting,
        overrideBaseTargeting: false,
        mergeBaseTargeting: false,
      });
      const newBannerConfig: IAdvertisingConfigRaw['bannerConfig'] = Object.assign(bannerConfig, {
        targeting: mergeSharedTargeting,
      });
      return newBannerConfig;
    }
  }
  return undefined;
};

const _MainWrapperAds = ({ pageJson }: { pageJson: JsonResultType }) => {
  const interstitialData = getInterstitialData(pageJson);
  const skinData = getSkinData(pageJson);
  const bannerConfig = getBannerAdData(pageJson);

  return (
    <>
      <InterstitialPortal interstitialPayload={interstitialData} />
      <AdPageInitProvider rendersBannerAd={!!bannerConfig?.fuseTag}>
        <AdvertSkins skin={skinData}>
          <MainPageLayoutV2 pageJson={pageJson}>
            <BannerAd bannerConfig={bannerConfig} />
          </MainPageLayoutV2>
        </AdvertSkins>
      </AdPageInitProvider>
    </>
  );
};
/** We need to use this as otherwise we have additional renders take place */
export const MainWrapperAdsV2 = React.memo(_MainWrapperAds);
